import React, {useRef} from "react"
import { connect } from "react-redux"
import { Form as BootstrapForm } from "react-bootstrap"
import { FormikProps } from "formik/dist/types";
import classNames from "classnames"
import DatePicker, {CalendarContainer, registerLocale} from "react-datepicker"
import vi from "date-fns/locale/vi";
import en from "date-fns/locale/en-GB";

import {
  areDatesValid,
  getMaxTimeLimit, getMinTimeLimit,
  ISOStringToDate, onPickISOStringDate
} from "../../../../helpers/dateHelper";
import {hasBeenFilled} from "../../../../helpers/dynamicFormHelper";
import {warningToastNotification} from "../../../../helpers/toastNotificationHelper";
import {ConfigurationsType} from "../../../../types/configurations";
import {ShapeType} from "../../../../types/shape";
import {ProductImageStacType} from "../../../../types/product";
import translations from "../../../../translations";
import {AppParametersType} from "../../../../types/app";

interface PropsType {
  configurations: ConfigurationsType,
  scopeConfigurationFields: string,
  disabled?: boolean,
  selectedArea: ShapeType,
  selectedProducts: ProductImageStacType[],
  formProps: FormikProps<any>,
  fieldName: string,
  secondaryFieldName: string,
  containerClassName: string,
  minDate: Date,
  maxDate: Date,
  language: string,
  appParameters: AppParametersType,
}

const DateFieldSelector = (props: PropsType) => {
  const {
    fieldName,
    secondaryFieldName,
    configurations,
    scopeConfigurationFields,
    selectedArea,
    formProps,
    disabled,
    containerClassName,
    minDate,
    maxDate,
    language,
    appParameters
  } = props;

  const {
    values,
    setFieldValue,
    touched,
    errors,
  } = formProps;

  const selectedDate = ISOStringToDate(values[fieldName]);
  const inputToDateRef = useRef<any>(null);
  const isFromDate = fieldName === "date1";
  const currentDate = selectedDate || (maxDate) || minDate; // @mapitaly non legato ad routine e maxDate
  const labelText = isFromDate ? "From" : "To";
  const secondaryLabelText = isFromDate ? "To" : "From";

  switch (language) {
    case "vi":
      registerLocale("vi", vi);
    default:
      registerLocale("en", en);
  }

  return (
    <div
      className={
        classNames(containerClassName, {
          "is-invalid": !!errors[fieldName] && !!touched[fieldName]
        })
      }
    >
      <span className="absolute-top-label">{`${translations(labelText, language)}:`}</span>
      <DatePicker
        id={fieldName}
        isClearable
        ref={inputToDateRef}
        name={fieldName}
        className="form-control transparent px-1"
        type="text"
        disabled={disabled && hasBeenFilled(values[secondaryFieldName])}
        selected={selectedDate}
        popperPlacement="top"
        dateFormat="yyyy/MM/dd, HH:mm"
        autoComplete="off"
        showTimeSelect
        // @mapitaly: il locale non se lo prende e da millemila errori TODO: capire perchè, anche se già così funziona
        // locale={language}
        showYearDropdown
        // @mapitaly: sempre true, non legato ad routine
        scrollableYearDropdown
        yearDropdownItemNumber={200}
        timeIntervals={1}
        timeFormat="HH:mm"
        showPopperArrow={false}
        popperModifiers={{
          flip: {
            enabled: false
          },
          preventOverflow: {
            enabled: true,
            escapeWithReference: false
          }
        }}
        calendarContainer={({ className, children }) => (
          <>
            <div className="calendar-title">
              <p className="m-0">
                <span>
                  {translations("pleaseSelectSearchFilters", language)}
                  {" "}
                </span>
                <b>{labelText}</b>
                <span>
                  {" "}
                  {translations("dateLeftSearchBar", language)}
                </span>
              </p>
            </div>
            <CalendarContainer className={className}>
              {children}
            </CalendarContainer>
          </>
        )}
        openToDate={currentDate}
        minDate={minDate}
        minTime={getMinTimeLimit(currentDate, minDate)}
        maxDate={maxDate}
        maxTime={getMaxTimeLimit(currentDate, maxDate)}
        onChange={(newPickedDate: Date) => {
          // if (inputToDateRef) {
          //   inputToDateRef.current.setOpen(false);
          // }

          const dateISOString = !newPickedDate ?
            "" : onPickISOStringDate(
              newPickedDate,
              currentDate,
              minDate,
              maxDate
            )

          const nextValues = {
            ...values,
            [fieldName]: dateISOString
          }

          setFieldValue(fieldName, dateISOString);
          if (!areDatesValid(configurations, appParameters, scopeConfigurationFields, nextValues, selectedArea)) {
            setFieldValue(secondaryFieldName, "");
            warningToastNotification(`${translations("dateInvalidDateField", language).replace("${secondaryLabelText}", secondaryLabelText)}`);
          }
        }}
      />
      <BootstrapForm.Control.Feedback className="absolute" type="invalid">{errors[fieldName]}</BootstrapForm.Control.Feedback>
    </div>
  )
}

const mapStateToProps = (state) => ({
  language: state.application.appParameters.language,
  appParameters: state.application.appParameters,
});

export default connect(mapStateToProps)(DateFieldSelector)
